module.exports = "https://r.zoocdn.com/_next/static/images/restrict-processing-13c4246f27515f7fd01e3a580ed5a5ef.svg";